<template>
  <main class="whats-new kt-portlet">
    <h1 class="d-none">Gameplan</h1>
    <h2 class="d-none">Dealer sales tools, made easy</h2>

    <HowItWorksModal :videoUrl="howItWorksVideoUrl" />
    <header id="gameplan-header" class="row no-gutters justify-content-between">
      <div class="col-lg-4 mb-3 mb-lg-0 flex flex-column left-column">
        <h2>
          Drive sales with the power of personalized catalogs and sales sheets.
        </h2>
        <ul class="indications">
          <li class="indications-item">
            <img
              src="@/assets/icons/ui/arrow_homepage.png"
              alt="arrow"
            />Playbooks are easy-to-make custom catalogs
          </li>
          <li class="indications-item">
            <img src="@/assets/icons/ui/arrow_homepage.png" alt="arrow" />Snap
            Sheets are easy-to-make custom sales sheets.
          </li>
          <li class="indications-item">
            <img src="@/assets/icons/ui/arrow_homepage.png" alt="arrow" />Your
            branding, their colors and name. Easy and fast.
          </li>
        </ul>
        <div class="create-projects-buttons-container">
          <a
            class="btn btn-project"
            :href="fsgSiteCreatePlaybookUrl"
            target="_blank"
          >
            Create Playbook
          </a>
          <a
            class="btn btn-project"
            :href="fsgSiteCreateSnapsheetUrl"
            target="_blank"
          >
            Create Snapsheet
          </a>
        </div>
      </div>
      <div class="col-lg-6 right-column">
        <img
          src="@/assets/gameplan-home.png"
          alt="products example"
          class="img-fluid d-block m-auto"
        />
      </div>
    </header>

    <section id="why-use-gameplan">
      <p class="section-label">Why use Playbooks or snapsheets?</p>
      <h2>
        Create personalized sales materials without the design time or hassle.
      </h2>
      <article class="three-columns-container">
        <div class="column-item flex flex-column">
          <h3>Your Branding</h3>
          <p class="column-item-text">
            Every project you create features your company's logo and contact
            information so your customers can easily follow up woth you and move
            the order along.
          </p>
        </div>
        <div class="column-item flex flex-column">
          <h3>Their colors</h3>
          <p class="column-item-text">
            Our exclusive technology helps you present the perfect product
            assortment to your customer with everything displayed in their
            colors.
          </p>
        </div>
        <div class="column-item flex flex-column">
          <h3>Easy & Fast</h3>
          <p class="column-item-text">
            Creating projects only take a matter of seconds, not hours. Once you
            are ready, send customers their catalog or sales sheet via a custom
            URL or download it to present in-person.
          </p>
        </div>
      </article>
    </section>

    <section id="projects-info">
      <p class="section-label">Products</p>
      <h2>Unleash your sales potential with our free tools.</h2>

      <article class="project-container">
        <div class="project-info-container">
          <div class="project-title">
            <img
              src="@/assets/icons/ui/icon_catalog.svg"
              alt="playbook icon"
            />
            <h3>Don't show a catalog, show a Playbook!</h3>
          </div>
          <div class="project-text-info">
            <p>
              Playbooks are custom catalogs for schools, travel teams, or
              businesses. Build a Playbook in seconds and your customers can
              select, customize, and send you a quote request for the uniforms
              and gear they want.
            </p>
            <p>
              Perfect for
              <strong> high schools, middle schools, and travel teams.</strong>
            </p>
          </div>
          <router-link
            class="btn btn-project"
            :to="'/dashboard/create_project/playbook'"
          >
            Create Playbook
          </router-link>
        </div>
        <div class="project-image-container playbook">
          <img
            src="@/assets/icons/ui/playbook-preview.png"
            alt="snapsheet preview"
          />
        </div>
      </article>

      <article class="project-container">
        <div class="project-info-container">
          <div class="project-title">
            <img
              src="@/assets/icons/ui/icon_snapsheet.svg"
              alt="snapsheet icon"
            />
            <h3>Don't show sales sheet, show a Snapsheet!</h3>
          </div>
          <div class="project-text-info">
            <p>
              Snapsheets are custom sales sheets designed for businesses, youth
              organizations, or clubs. Select product categories and colors, and
              let your customer browse and select performance gear for you to
              quote. We help you bring it all together in an instant to save you
              time.
            </p>
            <p>
              Perfect for
              <strong> corporate clients, spiritwear, and school clubs.</strong>
            </p>
          </div>
          <router-link
            class="btn btn-project"
            :to="'/dashboard/create_project/snapsheet'"
          >
            Create Snapsheet
          </router-link>
        </div>
        <div class="project-image-container snapsheet">
          <img
            src="@/assets/icons/ui/snapsheet-preview.png"
            alt="snapsheet preview"
          />
        </div>
      </article>
    </section>
  </main>
</template>

<script>
import axios from "axios";
import HowItWorksModal from "@/components/Dashboard/Homepage/HowItWorksModal";
import { mapGetters, mapState } from "vuex";

export default {
  name: "Homepage",
  components: {
    HowItWorksModal,
    // AnnotatedImage
  },
  computed: {
    ...mapState(["auth"]),
    ...mapGetters("project", [
      "fsgSiteCreatePlaybookUrl",
      "fsgSiteCreateSnapsheetUrl",
    ]),
  },
  mounted() {
    this.$store.commit("setActivePage", "Get Started");

    this.omgAccountNumber = this.$store.state.dealer.omg_account_number;

    window.scrollTo({
      top: document.getElementById("kt_header").offsetTop,
      behavior: "smooth",
    });
  },
  methods: {
    query(type) {
      return {
        ...this.$route.query,
        ...{ type },
      };
    },
    goTo(type) {
      this.$router.push({ name: "Create New Project", params: { type: type } });
    },
    selectVideo(url) {
      this.howItWorksVideoUrl = url;
    },
    sendOMGAccountNumber() {
      if (this.loading || !this.omgAccountNumber) return false;
      this.loading = true;
      let params = {
        omg_account_number: this.omgAccountNumber,
        _method: "put",
      };
      axios
        .post(this.$store.state.settings.endpoint + "api/v2/dealer", params, {
          headers: {
            Authorization: "Bearer " + this.auth.apiToken,
          },
        })
        .then(() => {
          this.loading = false;
          this.savedOMGAccountNumber = true;
          this.$store.commit("setAccountNumber", {
            omgAccountNumber: this.omgAccountNumber,
          });
        })
        .catch((error) => {
          this.$store.dispatch("showToast", {
            txt: error,
            type: "error",
          });
          this.loading = false;
        });
    },
  },
  data() {
    return {
      loading: false,
      omgAccountNumber: "",
      savedOMGAccountNumber: false,
      howItWorksVideoUrl: "",
    };
  },
};
</script>

<style lang="scss" scoped>
.whats-new {
  background: $grey-lightest;
  padding: 5%;
  h2 {
    margin-bottom: 1.5rem;
    font-family: "ForzaBold" !important;
    line-height: 3rem !important;
  }
  p.section-label {
    font-weight: bold !important;
    text-transform: uppercase !important;
    margin-bottom: 0.5rem !important;
  }
  span.label-red {
    font-weight: bold;
    color: $snapsheetColor;
    text-transform: uppercase;
    margin-bottom: 1rem;
  }
  .btn-project {
    background: $dark;
    color: white;
    border-radius: 6px;
    margin-right: 1.5rem;
    width: fit-content;
  }
  #gameplan-header {
    margin-bottom: 5rem;
    .create-projects-buttons-container {
      display: flex;
    }
    .left-column {
      padding-top: 5%;
      ul {
        list-style: none;
        li {
          margin-bottom: 0.75rem;
          display: flex;
          align-items: center;
          img {
            margin-right: 1rem;
          }
        }
      }
    }

    @media screen and (max-width: 1024px) {
      height: auto;

      .first-column {
        margin-bottom: 2rem;
        align-items: center;
        text-align: center;
        padding: 3rem 1.5rem;
        .text-container.first-column-info {
          height: auto;
        }
      }

      .second-column {
        .dealer-info-example {
          margin-left: 0;
        }
      }

      .third-column {
        padding: 1rem;
        article {
          padding: 1rem;
          margin-bottom: 0.5rem;
        }
      }
    }

    @media screen and (max-width: 768px) {
      .second-column {
        padding-top: 0.5rem;
      }

      .third-column {
        article {
          padding: 0.5rem;
          margin-bottom: 0.5rem;
          text-align: center;
        }
      }

      .display-none-mobile {
        display: none !important;
      }
    }
  }

  #why-use-gameplan,
  #steps {
    margin-bottom: 10rem;
    h2 {
      margin-bottom: 3rem;
      width: 50%;
    }

    .three-columns-container {
      display: flex;
      justify-content: space-between;
      gap: 2rem;

      .column-item {
        width: 30%;

        h3 {
          font-weight: bold;
          margin-bottom: 1rem;
        }

        .column-item-text {
          line-height: 2rem;
        }
      }
    }
  }

  #projects-info {
    margin-bottom: 5rem;
    h2 {
      margin-bottom: 5rem;
      width: 50%;
    }
    .project-container {
      display: flex;
      margin-bottom: 4rem;
      .project-info-container {
        width: 50%;

        .project-title {
          display: flex;
          align-items: center;
          margin-bottom: 2rem;
          h3 {
            font-weight: bold;
            font-size: 2rem;
          }
          img {
            margin-right: 1.5rem;
            width: 2rem;
            height: 2rem;
          }
        }

        .project-text-info {
          margin-bottom: 3rem;
          p {
            line-height: 2rem;
            &:first-child {
              margin-bottom: 2rem;
            }
          }
        }
      }
      .project-image-container {
        width: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        &.snapsheet {
          background: linear-gradient(
            -120deg,
            $snapsheetColor 55%,
            rgba(0, 0, 0, 0) 30%
          );
        }
        &.playbook {
          background: linear-gradient(
            -120deg,
            $playbookColor 55%,
            rgba(0, 0, 0, 0) 30%
          );
        }
        img {
          max-width: 100%;
          height: 80%;
        }
      }
    }
  }

  #faq-section {
    * {
      color: $dark;
      background: $grey-lightest;
    }
    .card-title {
      padding: 2rem 1rem 1rem 0;
      h5 {
        font-size: 1.4rem;
      }
    }
    .kt-portlet__head {
      h2 {
        font-size: 1.75em;
      }
    }
  }
}
</style>
